import {
  Heart,
  Star,
  ThumbsUp,
  ThumbsDown,
  Smile,
  Frown,
  Meh,
  Laugh,
  Angry,
  Home,
  Building,
  Building2,
  Store,
  Briefcase,
  GraduationCap,
  User,
  Users,
  UserPlus,
  Baby,
  PawPrint,
  Dog,
  Cat,
  Bird,
  Fish,
  Leaf,
  Flower,
  TreePine,
  Sun,
  Moon,
  CloudRain,
  Snowflake,
  Flame,
  Droplet,
  Globe,
  MapPin,
  Plane,
  Car,
  Bike,
  Bus,
  Train,
  Ship,
  Rocket,
  ShoppingCart,
  ShoppingBag,
  CreditCard,
  DollarSign,
  Gift,
  Tag,
  Package,
  Truck,
  Phone,
  Mail,
  MessageCircle,
  Bell,
  Calendar,
  Clock,
  Camera,
  Image,
  Video,
  Music,
  Headphones,
  Mic,
  Book,
  BookOpen,
  Pencil,
  Pen,
  Paperclip,
  FileText,
  Folder,
  Clipboard,
  Lightbulb,
  Zap,
  Award,
  Trophy,
  Medal,
  Crown,
  Flag,
  Target,
  Coffee,
  Pizza,
  Apple,
  Wine,
  Utensils,
  Cake,
  Dumbbell,
  Activity,
  Footprints,
  Stethoscope,
  Pill,
  Cross,
  Shield,
  Lock,
  Key,
  Settings,
  Wrench,
  Hammer,
  Laptop,
  Smartphone,
  Monitor,
  Wifi,
  Battery,
  Cloud,
  Database,
  Code,
  Palette,
  Brush,
  Scissors,
  Puzzle,
  Gamepad2,
  Dices,
  Sparkles,
  CheckCircle,
  XCircle,
  AlertCircle,
  HelpCircle,
  Info,
} from "lucide-react";

export const ICON_PREFIX = "icon:";

export const isIconValue = (value) =>
  typeof value === "string" && value.startsWith(ICON_PREFIX);

export const iconNameFromValue = (value) =>
  isIconValue(value) ? value.slice(ICON_PREFIX.length) : null;

export const iconValueFromName = (name) => `${ICON_PREFIX}${name}`;

export const PICTURE_CHOICE_ICONS = [
  { name: "Heart", keywords: "love like favorite", Icon: Heart },
  { name: "Star", keywords: "favorite rate rating", Icon: Star },
  { name: "ThumbsUp", keywords: "yes good like agree", Icon: ThumbsUp },
  { name: "ThumbsDown", keywords: "no bad dislike disagree", Icon: ThumbsDown },
  { name: "Smile", keywords: "happy face emoji good", Icon: Smile },
  { name: "Frown", keywords: "sad face emoji unhappy", Icon: Frown },
  { name: "Meh", keywords: "neutral face okay", Icon: Meh },
  { name: "Laugh", keywords: "happy laughing face", Icon: Laugh },
  { name: "Angry", keywords: "mad upset face", Icon: Angry },
  { name: "Home", keywords: "house building", Icon: Home },
  { name: "Building", keywords: "office company work", Icon: Building },
  { name: "Building2", keywords: "office company city", Icon: Building2 },
  { name: "Store", keywords: "shop retail business", Icon: Store },
  { name: "Briefcase", keywords: "work job business", Icon: Briefcase },
  { name: "GraduationCap", keywords: "school education student", Icon: GraduationCap },
  { name: "User", keywords: "person account profile", Icon: User },
  { name: "Users", keywords: "people group team", Icon: Users },
  { name: "UserPlus", keywords: "add person invite", Icon: UserPlus },
  { name: "Baby", keywords: "child kid infant", Icon: Baby },
  { name: "PawPrint", keywords: "animal pet paw", Icon: PawPrint },
  { name: "Dog", keywords: "animal pet dog", Icon: Dog },
  { name: "Cat", keywords: "animal pet cat", Icon: Cat },
  { name: "Bird", keywords: "animal bird", Icon: Bird },
  { name: "Fish", keywords: "animal fish sea", Icon: Fish },
  { name: "Leaf", keywords: "nature plant eco", Icon: Leaf },
  { name: "Flower", keywords: "nature plant flower", Icon: Flower },
  { name: "TreePine", keywords: "nature tree forest", Icon: TreePine },
  { name: "Sun", keywords: "weather sunny day", Icon: Sun },
  { name: "Moon", keywords: "weather night dark", Icon: Moon },
  { name: "CloudRain", keywords: "weather rain", Icon: CloudRain },
  { name: "Snowflake", keywords: "weather snow cold winter", Icon: Snowflake },
  { name: "Flame", keywords: "fire hot", Icon: Flame },
  { name: "Droplet", keywords: "water drop liquid", Icon: Droplet },
  { name: "Globe", keywords: "world earth global", Icon: Globe },
  { name: "MapPin", keywords: "location place map", Icon: MapPin },
  { name: "Plane", keywords: "travel flight airplane", Icon: Plane },
  { name: "Car", keywords: "vehicle travel drive", Icon: Car },
  { name: "Bike", keywords: "bicycle cycle", Icon: Bike },
  { name: "Bus", keywords: "transport vehicle", Icon: Bus },
  { name: "Train", keywords: "transport rail", Icon: Train },
  { name: "Ship", keywords: "boat sea travel", Icon: Ship },
  { name: "Rocket", keywords: "launch space startup", Icon: Rocket },
  { name: "ShoppingCart", keywords: "buy store cart", Icon: ShoppingCart },
  { name: "ShoppingBag", keywords: "buy store bag", Icon: ShoppingBag },
  { name: "CreditCard", keywords: "payment money card", Icon: CreditCard },
  { name: "DollarSign", keywords: "money price cost", Icon: DollarSign },
  { name: "Gift", keywords: "present reward", Icon: Gift },
  { name: "Tag", keywords: "price label sale", Icon: Tag },
  { name: "Package", keywords: "box delivery shipping", Icon: Package },
  { name: "Truck", keywords: "delivery shipping transport", Icon: Truck },
  { name: "Phone", keywords: "call contact", Icon: Phone },
  { name: "Mail", keywords: "email message contact", Icon: Mail },
  { name: "MessageCircle", keywords: "chat message talk", Icon: MessageCircle },
  { name: "Bell", keywords: "notification alert", Icon: Bell },
  { name: "Calendar", keywords: "date schedule event", Icon: Calendar },
  { name: "Clock", keywords: "time schedule", Icon: Clock },
  { name: "Camera", keywords: "photo picture", Icon: Camera },
  { name: "Image", keywords: "photo picture media", Icon: Image },
  { name: "Video", keywords: "movie media film", Icon: Video },
  { name: "Music", keywords: "audio song sound", Icon: Music },
  { name: "Headphones", keywords: "audio music listen", Icon: Headphones },
  { name: "Mic", keywords: "audio record voice", Icon: Mic },
  { name: "Book", keywords: "read education", Icon: Book },
  { name: "BookOpen", keywords: "read education learn", Icon: BookOpen },
  { name: "Pencil", keywords: "write edit draw", Icon: Pencil },
  { name: "Pen", keywords: "write edit", Icon: Pen },
  { name: "Paperclip", keywords: "attach file", Icon: Paperclip },
  { name: "FileText", keywords: "document file", Icon: FileText },
  { name: "Folder", keywords: "file directory", Icon: Folder },
  { name: "Clipboard", keywords: "copy notes list", Icon: Clipboard },
  { name: "Lightbulb", keywords: "idea tip insight", Icon: Lightbulb },
  { name: "Zap", keywords: "energy power fast", Icon: Zap },
  { name: "Award", keywords: "prize achievement", Icon: Award },
  { name: "Trophy", keywords: "win prize champion", Icon: Trophy },
  { name: "Medal", keywords: "win prize award", Icon: Medal },
  { name: "Crown", keywords: "king premium best", Icon: Crown },
  { name: "Flag", keywords: "country goal mark", Icon: Flag },
  { name: "Target", keywords: "goal aim focus", Icon: Target },
  { name: "Coffee", keywords: "drink cafe break", Icon: Coffee },
  { name: "Pizza", keywords: "food eat", Icon: Pizza },
  { name: "Apple", keywords: "food fruit healthy", Icon: Apple },
  { name: "Wine", keywords: "drink alcohol bar", Icon: Wine },
  { name: "Utensils", keywords: "food eat restaurant", Icon: Utensils },
  { name: "Cake", keywords: "food birthday dessert", Icon: Cake },
  { name: "Dumbbell", keywords: "gym fitness workout", Icon: Dumbbell },
  { name: "Activity", keywords: "health pulse fitness", Icon: Activity },
  { name: "Footprints", keywords: "walk steps", Icon: Footprints },
  { name: "Stethoscope", keywords: "doctor health medical", Icon: Stethoscope },
  { name: "Pill", keywords: "medicine health drug", Icon: Pill },
  { name: "Cross", keywords: "health medical hospital", Icon: Cross },
  { name: "Shield", keywords: "security protect safe", Icon: Shield },
  { name: "Lock", keywords: "security private safe", Icon: Lock },
  { name: "Key", keywords: "access unlock", Icon: Key },
  { name: "Settings", keywords: "gear options config", Icon: Settings },
  { name: "Wrench", keywords: "tool fix repair", Icon: Wrench },
  { name: "Hammer", keywords: "tool build fix", Icon: Hammer },
  { name: "Laptop", keywords: "computer device work", Icon: Laptop },
  { name: "Smartphone", keywords: "phone mobile device", Icon: Smartphone },
  { name: "Monitor", keywords: "screen computer display", Icon: Monitor },
  { name: "Wifi", keywords: "internet network connection", Icon: Wifi },
  { name: "Battery", keywords: "power charge energy", Icon: Battery },
  { name: "Cloud", keywords: "weather storage", Icon: Cloud },
  { name: "Database", keywords: "data storage server", Icon: Database },
  { name: "Code", keywords: "develop programming", Icon: Code },
  { name: "Palette", keywords: "art color design", Icon: Palette },
  { name: "Brush", keywords: "paint art design", Icon: Brush },
  { name: "Scissors", keywords: "cut tool", Icon: Scissors },
  { name: "Puzzle", keywords: "game piece solve", Icon: Puzzle },
  { name: "Gamepad2", keywords: "game play controller", Icon: Gamepad2 },
  { name: "Dices", keywords: "game random luck", Icon: Dices },
  { name: "Sparkles", keywords: "magic ai shine new", Icon: Sparkles },
  { name: "CheckCircle", keywords: "yes done correct ok", Icon: CheckCircle },
  { name: "XCircle", keywords: "no wrong cancel", Icon: XCircle },
  { name: "AlertCircle", keywords: "warning alert", Icon: AlertCircle },
  { name: "HelpCircle", keywords: "question help unknown", Icon: HelpCircle },
  { name: "Info", keywords: "information detail", Icon: Info },
];

const ICON_MAP = PICTURE_CHOICE_ICONS.reduce((acc, item) => {
  acc[item.name] = item.Icon;
  return acc;
}, {});

export const getPictureChoiceIcon = (name) => ICON_MAP[name] || null;
